/**
 * tokens.js
 * ---------------------------------------------------------------------------
 * Design tokens — the single source of truth for colors used across the UI.
 *
 * Institutional palette: deep navy on white, muted support tones, single
 * restrained accent. Matches the brief's requirement for high-trust,
 * calm, minimal aesthetics (Skadden / Latham / Wachtell sensibility).
 */

export const tokens = {
  bg: "#FFFFFF",
  ink: "#0B1F3B",        // deep navy — primary text
  inkSoft: "#4A5568",    // secondary text
  accent: "#2B6CB0",     // restrained blue accent
  divider: "#E2E8F0",    // hairline dividers
  paper: "#FAFAF7",      // alternating section background
  hairline: "#CBD5E0",   // input borders
};

export const typography = {
  display: "'Cormorant Garamond', 'Times New Roman', serif",
  body: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
};

export const layout = {
  maxWidth: 1200,
  sectionPadY: 120,
  sectionPadX: 32,
};
